<template>
    <v-dialog persistent v-model="dialog" max-width="290">
        <v-card>

            <v-card-title class="headline">
                {{$t('Pages.Vacations.title_respond_dialog')}}
                <v-btn small absolute right icon dark @click="onClose">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-textarea
                        v-validate="'required'"
                        v-model="comment"
                        :error-messages="errors.first('comment')"
                        :label="$t('Pages.Vacations.model.comment')"
                        type="text"
                        color="info"
                        required
                        name="comment"
                />
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                        color="error darken-1"
                        @click="decline"
                        :disabled="loading"
                >
                    {{$t('Common.decline')}}
                </v-btn>

                <v-btn :disabled="loading"
                        color="info darken-1"
                        @click="approve"
                >
                    {{$t('Common.approve')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import _ from 'lodash';
export default {
    name: 'respond-dialog',
  components: {},
  props: {
      dialog: {
          type: Boolean,
          default: false
      },
      id: {
          required: true
      }
  },
  data: () => ({
    comment: '',
    loading: false,
  }),
  computed: {
  },
  created () {

  },
  methods: {
        onClose(refresh = false){
            this.$emit('close', refresh);
      },
      approve(){
          let data = {
              vacation_request_id: this.id,
              description: this.comment
          };

          this.loading = true;
          this.repositories.vacationResponse.approve(data).then((response) => {
                this.$toast.info(response.data.message);

            }).finally(() => {
             this.loading = false;
              this.onClose(true);
          });
      },
      decline(){
          this.loading = true;
          let data = {
                vacation_request_id: this.id,
                description: this.comment
          };
          this.repositories.vacationResponse.decline(data).then((response) => {
                this.$toast.info(response.data.message);

          }).finally(() => {
              this.loading = false;
              this.onClose(true);
        });
      }
  },
    watch:{

    }
}
</script>

<style lang="scss">

</style>
